import React from 'react';

import 'assets/scss/dashboard.css';

const DashboardGuide = () => {
  return (
    <div className="dashboard-guide">
    	<p className="greeting">
    		Hi, there.
    	</p>

    	<p className="greeting">
    		This is your dashboard where we'll show you your Measures of Success.
    	</p>

    	<p className="greeting">
    		You can configure different components to include metrics from your surveys, participants and so much more!
    	</p>

    	<div className="instructions">
	    	<p className="intro">To get started:</p>
	    	<ol className="howto-steps">
				<li>
					Click the + button below to add different metrics to your dashboard
		    	</li>
				<li>
		    		Configure the components so that they show the metrics that are most important to you
				</li>
				<li>
		    		Come back here often to get a quick glance of your survey progress
				</li>
	    	</ol>
    	</div>
    </div>
  );
}

export default DashboardGuide;




// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardGuide.js